module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_03.59223136.png";